import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-six-three-one',
  templateUrl: './two-six-three-one.component.html',
  styleUrls: ['./two-six-three-one.component.scss']
})
export class TwoSixThreeOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
